import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Entity } from 'src/app/classes/entity.class';
import { Hiring } from 'src/app/classes/hiring';
import { DialogService } from 'src/app/services/dialog/dialog.service';
import { EntitiesService } from 'src/app/services/entities/entities.service';
import { EntityType, EntityTypeCode } from 'src/app/services/entities/entity-type.class';
import { HiringService } from 'src/app/services/hiring.service';
import { HiringCompanyEditDialogComponent } from './hiring-company-edit-dialog/hiring-company-edit-dialog.component';

@Component({
    selector: 'app-hiring-companies-dialog',
    templateUrl: './hiring-companies-dialog.component.html',
    styleUrls: ['./hiring-companies-dialog.component.scss'],
    standalone: false,
})
export class HiringCompaniesDialogComponent implements OnInit, OnDestroy {
    forHiring = [EntityTypeCode.Wipetruck, EntityTypeCode.Cutter];

    hiringList: Hiring[];
    entityTypes: Map<string, EntityType>;

    private subscriptions = new Subscription();

    constructor(
        public dialogRef: MatDialogRef<HiringCompaniesDialogComponent>,
        public dialogService: DialogService,
        private hiringService: HiringService,
        private entitiesService: EntitiesService
    ) {}

    ngOnInit(): void {
        this.subscriptions.add(
            this.entitiesService.getTypesMap().subscribe(data => {
                this.entityTypes = data;
            })
        );
        this.subscriptions.add(
            this.hiringService.getAll().subscribe(hiringList => {
                this.hiringList = hiringList;
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    open(hiring: Hiring) {
        this.dialogService.open(HiringCompanyEditDialogComponent, hiring, { minHeight: 'auto' });
    }

    add(type: number) {
        const hiring = new Entity();
        hiring.entitytype_key = String(type);
        this.dialogService.open(HiringCompanyEditDialogComponent, hiring);
    }
}

export class HiringViewGroup {
    public type: string;
    public name: string;
    public companies: Hiring[];

    constructor(type: string, name: string, entities: Hiring[]) {
        this.type = type;
        this.name = name;
        this.companies = entities;
    }
}
